export const jobFinancialsInitialState = {
  actionsMenuDamageId: undefined as string | undefined,
  actionsMenuTransactionsId: undefined as string | undefined,
  actionsMenuInvoiceId: undefined as string | undefined,
  documentsSending: {} as { [ documentId: string ]: true },
  documentsUpdating: {} as { [ documentId: string ]: true },
  collapsedTransactionRemarks: {} as Record<string, boolean>,
} as const;
